export function formatMoneyUsd(amount: number, options?: { precision?: number }): string {
  if (typeof options?.precision === "number") {
    return `$${amount.toFixed(options.precision)}`;
  }

  if (amount === 0) return "$0.00";
  if (amount < 0.01) return `$${amount.toFixed(4)}`;
  return `$${amount.toFixed(2)}`;
}

export function MoneyValue({ amount, precision }: { amount: number; precision?: number }) {
  return <span>{formatMoneyUsd(amount, { precision })}</span>;
}
